/// <reference path="../types/index.d.ts" />

import '../client_forms/tcagbwed/style.css';
import FormStructure from './tcagbwed/form_structure';

export default FormStructure;